export const getAllAvailableBoards = {
  success: true,
  isApp: false,
  groups: [
    // change to "groups" so that it is more clear what the top level data is
    {
      // Everyone group
      ID: 2,
      name: "Test Net",
      slug: "testnet",
      image:
        "https://s3-us-west-2.amazonaws.com/dev-photos.flocknote.com/everyone/icon.png", // add the group image url
      order: 1,
      hierarchyLevel: 0, // make 0 the lowest level. I'm doing math on it to show the nesting.
      isEveryoneGroup: true, // so I can add a little distinction for the everyone group
      boards: [],
    },
    {
      ID: 3,
      name: "Parent Group",
      slug: "parent-group",
      image:
        "https://s3-us-west-2.amazonaws.com/dev-photos.flocknote.com/everyone/icon.png",
      order: 2,
      hierarchyLevel: 1,
      isEveryoneGroup: false,
      boards: [],
    },
    {
      ID: 4,
      name: "Child Group",
      slug: "child-group",
      image:
        "https://s3-us-west-2.amazonaws.com/dev-photos.flocknote.com/everyone/icon.png",
      order: 2,
      hierarchyLevel: 2,
      isEveryoneGroup: false,
      boards: [
        {
          ID: 234,
          name: "My Board",
          slug: "my-board",
        },
      ],
    },
  ],
  reportBoards: [
    {
      boardID: 123,
      boardName: "my first report",
      groups: [
        {
          ID: 1,
          name: "First test group",
        },
        {
          ID: 2,
          name: "Second test group",
        },
      ],
    },
    {
      boardID: 124,
      boardName: "2nd Test report",
      groups: [
        {
          ID: 1,
          name: "First test group",
        },
        {
          ID: 3,
          name: "third test group",
        },
      ],
    },
  ],
};

// export const getAllAvailableBoards = {
//   success: true,
//   isApp: false,
//   reportBoards: [
//     {
//       boardID: 123,
//       boardName: "my first report",
//       groups: [
//         {
//           ID: 1,
//           name: "First test group",
//         },
//         {
//           ID: 2,
//           name: "Second test group",
//         },
//       ],
//     },
//     {
//       boardID: 124,
//       boardName: "2nd Test report",
//       groups: [
//         {
//           ID: 1,
//           name: "First test group",
//         },
//         {
//           ID: 3,
//           name: "third test group",
//         },
//       ],
//     },
//   ],
//   groupBoards: [
//     {
//       // Parent with no boards
//       boardID: 200,
//       boardName: "test staff",
//       boardSlug: "teststaff",
//       groupID: 1,
//       groupName: "staff",
//       groupSlug: "staff",
//       parentGroupID: null,
//       disabled: true,
//       image: "https://placehold.co/100",
//     },
//     {
//       // Child with no board
//       boardID: 201,
//       boardName: "group report 200.2",
//       boardSlug: "groupreport2002",
//       groupID: 11,
//       groupName: "staff child",
//       groupSlug: "staff-child",
//       parentGroupID: 1,
//       disabled: true,
//       image:
//         "https://s3-us-west-2.amazonaws.com/dev-photos.flocknote.com/staff/icon.png",
//     },
//     {
//       // Grandchild with no board
//       boardID: 205,
//       boardName: "group report 200.3",
//       boardSlug: "groupreport2003",
//       groupID: 12,
//       groupName: "staff grandchild",
//       groupSlug: "staff-grandchild",
//       parentGroupID: 11,
//       disabled: false,
//       image: "https://dhdj1c2suf90g.cloudfront.net/images/nophoto.jpg",
//     },
//     {
//       // Parent with boards
//       boardID: 202,
//       boardName: "group report 201.1",
//       boardSlug: "groupreport2011",
//       groupID: 2,
//       groupName: "group 2",
//       groupSlug: "group2",
//       parentGroupID: 201,
//       disabled: false,
//       image: "https://dhdj1c2suf90g.cloudfront.net/images/nophoto.jpg",
//     },
//     {
//       boardID: 203,
//       boardName: "group report 201.2",
//       boardSlug: "groupreport2012",
//       groupID: 2,
//       groupName: "group 2",
//       groupSlug: "group2",
//       parentGroupID: null,
//       disabled: false,
//       image: "https://dhdj1c2suf90g.cloudfront.net/images/nophoto.jpg",
//     },
//   ],
// };
